/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestDiffViewerEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('NEW_AUTO_TEST_DIFF_VIEWER_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class NewAutoTestDiffViewerEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestDiffViewerEnabledSettingParser.decode(input).map(res => new NewAutoTestDiffViewerEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestDiffViewerEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestDiffViewerEnabledSettingParser.encode(data);
    }
    static schema() {
        return NewAutoTestDiffViewerEnabledSettingParser.schema();
    }
}
